import { render, staticRenderFns } from "./BetMatchDetailsSwiper.vue?vue&type=template&id=775dd796&scoped=true"
import script from "./BetMatchDetailsSwiper.vue?vue&type=script&lang=js"
export * from "./BetMatchDetailsSwiper.vue?vue&type=script&lang=js"
import style0 from "./BetMatchDetailsSwiper.vue?vue&type=style&index=0&id=775dd796&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775dd796",
  null
  
)

export default component.exports